let baseUrl = ''
let websocketUrl = ''
switch (process.env.NODE_ENV) {
  case 'development':
    baseUrl = 'http://172.30.24.121:8088/api'
    websocketUrl = 'http://172.30.24.121:8088/file_status'
    break
  case 'production':
    baseUrl = process.env.VUE_APP_BASEURL
    websocketUrl = process.env.VUE_APP_WEBSOCKETURL
    break
}
export {
  baseUrl, //导出baseUrl
  websocketUrl
}
